import React from 'react';
import { useField, useFormikContext } from 'formik';
import { Input } from '../ui/Input';
import { cn } from '../../utils/cn';

interface InputFormFieldProps {
  name: string;
  label?: string;
  type?: string;
  disabled?: boolean;
  placeholder?: string;
  limit?: number;
  className?: string;
  required?: boolean;
  [key: string]: unknown;
}

export const InputFormField: React.FC<InputFormFieldProps> = ({
  name,
  label,
  type = 'text',
  disabled,
  placeholder,
  limit,
  className,
  required,
}) => {
  const [field, meta] = useField(name);
  const { submitCount } = useFormikContext();
  const hasError = (meta.touched || submitCount > 0) && !!meta.error;
  const errorMsg = hasError ? meta.error : null;

  return (
    <div className={cn('flex flex-col gap-1', className)}>
      {label && (
        <label htmlFor={name} className="text-sm font-medium text-neutral-700">
          {label}
          {required && <span className="text-destructive ml-0.5">*</span>}
        </label>
      )}
      <Input
        id={name}
        data-testid={`input-form-field-${name}`}
        type={type}
        disabled={disabled}
        placeholder={placeholder}
        maxLength={limit}
        aria-invalid={hasError}
        {...field}
      />
      {hasError && <span className="text-destructive text-xs">{errorMsg}</span>}
    </div>
  );
};
